import { useCurrency } from '@/contexts/CurrencyContext';

const CurrencySwitcher = () => {
  const { displayCurrency, setDisplayCurrency, rates, ratesLoading } = useCurrency();

  const toggleCurrency = () => {
    setDisplayCurrency(displayCurrency === 'EUR' ? 'USD' : 'EUR');
  };

  return (
    <button
      onClick={toggleCurrency}
      className="terminal-border px-2 py-1.5 sm:px-3 sm:py-1.5 text-xs sm:text-sm font-mono bg-background hover:bg-primary/10 transition-colors whitespace-nowrap"
      aria-label="Toggle currency display"
    >
      <span className={displayCurrency === 'EUR' ? 'text-primary terminal-glow' : 'text-muted-foreground'}>
        €
      </span>
      <span className="text-muted-foreground mx-1">|</span>
      <span className={displayCurrency === 'USD' ? 'text-primary terminal-glow' : 'text-muted-foreground'}>
        $
      </span>
    </button>
  );
};

export default CurrencySwitcher;
